import React, {useState, useEffect, useContext, useRef, useCallback} from 'react';
import CommandsContext from '../../../../context/commandsContext';
import MenuContext from '../../../../context/menuContext';
import ValuesContext from '../../../../context/valuesContext';
import useKeyPress from '../../../../hooks/useKeyPress';
import NumberEntryView from '../../../views/numberEntryView';

function DecimalsOnDisplay({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const [value, setValue] = useState(1);
  const {onUpdateCommands} = useContext(CommandsContext);
  const {values, onUpdateValues} = useContext(ValuesContext);
  const {selected, setDisableMenu} = useContext(MenuContext);
  const inputRef = useRef();

  const onRight = useCallback(() => {
    onUpdateValues(selected.id, inputRef.current.value);
    onExit();
  }, [selected]);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands(commands => ({...commands, onLeft: onExit, onRight}));
    });
  }, [onExit, onRight]);

  useEffect(() => {
    if (values[selected.id]) {
      inputRef.current.value = values[selected.id];
    }
  }, [values, selected]);
  return (
    <NumberEntryView
      max={10}
      defaultValue={''}
      inputRef={inputRef}
      caption="Set Decimals on Display"
      title="Decimals on Display"
      left="Cancel"
      right="Save"
    />
  );
}

export default DecimalsOnDisplay;
